// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SearchSelect_select__KA0qu {
  position: relative;
  width: 100%;
  margin-bottom: 31px;
}
.SearchSelect_select__KA0qu input {
  width: 100%;
  height: 30px;
  padding: 0 26px 0 16px;
  background: #EEE;
  border-radius: 8px;
  color: #4B5058;
  font-size: var(--fz-sm);
}
@media (max-width: 640px) {
  .SearchSelect_select__KA0qu {
    margin: 24px 0;
  }
}
.SearchSelect_select__shorted__FJPHg {
  margin-bottom: 0;
}

.SearchSelect_input-container__enYlQ {
  display: flex;
  position: relative;
}

.SearchSelect_list-container__RQchM {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 264px;
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  z-index: 1;
  background: white;
  border-radius: 4px;
  max-height: 240px;
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 120px;
  border: 1px solid #E0E7EB;
  padding: 8px;
}
@media (max-width: 640px) {
  .SearchSelect_list-container__RQchM {
    max-width: none;
  }
}
.SearchSelect_list-container__RQchM .SearchSelect_select-item__sawgz {
  display: flex;
  gap: 8px;
  align-items: center;
  cursor: pointer;
  padding: 6px 4px;
  border-bottom: 1px solid #E0E7EB;
}
.SearchSelect_list-container__RQchM .SearchSelect_select-item__avatar__HUkwi {
  width: 24px;
  height: 24px;
}
.SearchSelect_list-container__RQchM .SearchSelect_select-item__info__mNT3Z {
  display: flex;
  flex-direction: column;
}
.SearchSelect_list-container__RQchM .SearchSelect_select-item__label__7ijvM {
  font-size: 12px;
  line-height: 114%;
}
.SearchSelect_list-container__RQchM .SearchSelect_select-item__position__OTzTo {
  font-size: 10px;
  color: #7A808B;
  line-height: 114%;
}
.SearchSelect_list-container__RQchM .SearchSelect_select-item__sawgz:hover {
  background: #EEE;
}
.SearchSelect_list-container__RQchM .SearchSelect_select-item__sawgz:last-child {
  border: none;
}
.SearchSelect_list-container__RQchM .SearchSelect_not-found__7XIZz {
  width: 100%;
  text-align: center;
}
.SearchSelect_list-container__clear__-RbgE {
  align-items: center;
  justify-content: center;
}
.SearchSelect_list-container__shorted__mqXz- {
  position: relative;
  top: 4px;
  border: none;
  padding: 0;
}

.SearchSelect_indicatorsContainer__T4Ae8 {
  display: flex;
  gap: 8px;
  position: absolute;
  right: 8px;
  top: calc(50% - 8px);
}
.SearchSelect_indicatorsContainer__T4Ae8 span {
  display: none;
}
.SearchSelect_indicatorsContainer__T4Ae8 div {
  display: flex;
  justify-content: center;
  padding: 0;
  align-items: center;
}
.SearchSelect_indicatorsContainer__T4Ae8 svg {
  color: #4B5058;
}
.SearchSelect_indicatorsContainer__icon-container__Kd-Zv {
  width: 16px;
  height: 16px;
}
.SearchSelect_indicatorsContainer__T4Ae8 .SearchSelect_close-icon__IlL8w {
  width: 16px;
  height: 16px;
  cursor: pointer;
}

.SearchSelect_grid__7JzGp {
  display: grid;
  grid-gap: 4px;
  margin-bottom: 12px;
}
.SearchSelect_grid--is-skeleton__CU-kZ {
  margin-bottom: 0;
}

.SearchSelect_skeleton__6muVP {
  width: 100%;
  height: 37px;
}`, "",{"version":3,"sources":["webpack://./src/components/SearchSelect/SearchSelect.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,WAAA;EACA,mBAAA;AACF;AACE;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EAEA,uBAAA;AAAJ;AAGE;EAhBF;IAiBI,cAAA;EAAF;AACF;AAEE;EACE,gBAAA;AAAJ;;AAIA;EACE,aAAA;EACA,kBAAA;AADF;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,OAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,yBAAA;EACA,YAAA;AADF;AAGE;EAlBF;IAmBI,eAAA;EAAF;AACF;AAEE;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;AAAJ;AAEI;EACE,WAAA;EACA,YAAA;AAAN;AAGI;EACE,aAAA;EACA,sBAAA;AADN;AAII;EACE,eAAA;EACA,iBAAA;AAFN;AAKI;EACE,eAAA;EACA,cAAA;EACA,iBAAA;AAHN;AAMI;EACE,gBAAA;AAJN;AAOI;EACE,YAAA;AALN;AASE;EACE,WAAA;EACA,kBAAA;AAPJ;AAUE;EACE,mBAAA;EACA,uBAAA;AARJ;AAWE;EACE,kBAAA;EACA,QAAA;EACA,YAAA;EACA,UAAA;AATJ;;AAaA;EACE,aAAA;EACA,QAAA;EACA,kBAAA;EACA,UAAA;EACA,oBAAA;AAVF;AAYE;EACE,aAAA;AAVJ;AAaE;EAEE,aAAA;EACA,uBAAA;EACA,UAAA;EACA,mBAAA;AAZJ;AAeE;EACE,cAAA;AAbJ;AAgBE;EACE,WAAA;EACA,YAAA;AAdJ;AAiBE;EACE,WAAA;EACA,YAAA;EACA,eAAA;AAfJ;;AAoBA;EACE,aAAA;EACA,aAAA;EACA,mBAAA;AAjBF;AAmBE;EACE,gBAAA;AAjBJ;;AAqBA;EACE,WAAA;EACA,YAAA;AAlBF","sourcesContent":[".select {\n  position: relative;\n  width: 100%;\n  margin-bottom: 31px;\n\n  input {\n    width: 100%;\n    height: 30px;\n    padding: 0 26px 0 16px;\n    background: #EEE;\n    border-radius: 8px;\n    color: #4B5058;\n\n    font-size: var(--fz-sm);\n  }\n\n  @media (max-width: 640px) {\n    margin: 24px 0;\n  }\n\n  &__shorted {\n    margin-bottom: 0;\n  }\n}\n\n.input-container {\n  display: flex;\n  position: relative;\n}\n\n.list-container {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  max-width: 264px;\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 0;\n  z-index: 1;\n  background: white;\n  border-radius: 4px;\n  max-height: 240px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  min-height: 120px;\n  border: 1px solid #E0E7EB;\n  padding: 8px;\n\n  @media (max-width: 640px) {\n    max-width: none;\n  }\n\n  .select-item {\n    display: flex;\n    gap: 8px;\n    align-items: center;\n    cursor: pointer;\n    padding: 6px 4px;\n    border-bottom: 1px solid #E0E7EB;\n\n    &__avatar {\n      width: 24px;\n      height: 24px;\n    }\n\n    &__info {\n      display: flex;\n      flex-direction: column;\n    }\n\n    &__label {\n      font-size: 12px;\n      line-height: 114%;\n    }\n\n    &__position {\n      font-size: 10px;\n      color: #7A808B;\n      line-height: 114%;\n    }\n\n    &:hover {\n      background: #EEE;\n    }\n\n    &:last-child {\n      border: none;\n    }\n  }\n\n  .not-found {\n    width: 100%;\n    text-align: center;\n  }\n\n  &__clear {\n    align-items: center;\n    justify-content: center;\n  }\n\n  &__shorted {\n    position: relative;\n    top: 4px;\n    border: none;\n    padding: 0;\n  }\n}\n\n.indicatorsContainer {\n  display: flex;\n  gap: 8px;\n  position: absolute;\n  right: 8px;\n  top: calc(50% - 8px);\n\n  span {\n    display: none;\n  }\n\n  div {\n\n    display: flex;\n    justify-content: center;\n    padding: 0;\n    align-items: center;\n  }\n\n  svg {\n    color: #4B5058;\n  }\n\n  &__icon-container {\n    width: 16px;\n    height: 16px;\n  }\n\n  .close-icon {\n    width: 16px;\n    height: 16px;\n    cursor: pointer;\n  }\n\n}\n\n.grid {\n  display: grid;\n  grid-gap: 4px;\n  margin-bottom: 12px;\n\n  &--is-skeleton {\n    margin-bottom: 0;\n  }\n}\n\n.skeleton {\n  width: 100%;\n  height: 37px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"select": `SearchSelect_select__KA0qu`,
	"select__shorted": `SearchSelect_select__shorted__FJPHg`,
	"input-container": `SearchSelect_input-container__enYlQ`,
	"list-container": `SearchSelect_list-container__RQchM`,
	"select-item": `SearchSelect_select-item__sawgz`,
	"select-item__avatar": `SearchSelect_select-item__avatar__HUkwi`,
	"select-item__info": `SearchSelect_select-item__info__mNT3Z`,
	"select-item__label": `SearchSelect_select-item__label__7ijvM`,
	"select-item__position": `SearchSelect_select-item__position__OTzTo`,
	"not-found": `SearchSelect_not-found__7XIZz`,
	"list-container__clear": `SearchSelect_list-container__clear__-RbgE`,
	"list-container__shorted": `SearchSelect_list-container__shorted__mqXz-`,
	"indicatorsContainer": `SearchSelect_indicatorsContainer__T4Ae8`,
	"indicatorsContainer__icon-container": `SearchSelect_indicatorsContainer__icon-container__Kd-Zv`,
	"close-icon": `SearchSelect_close-icon__IlL8w`,
	"grid": `SearchSelect_grid__7JzGp`,
	"grid--is-skeleton": `SearchSelect_grid--is-skeleton__CU-kZ`,
	"skeleton": `SearchSelect_skeleton__6muVP`
};
export default ___CSS_LOADER_EXPORT___;
